/**
 *
 * @returns {string|null}
 */
export default function getCurrentBrand() {
  if (window.location.hostname.startsWith('storybook')) {
    return 'valentino';
  }

  switch (window.location.hostname) {
    case process.env.REACT_APP_DOMAIN.replace('{brand}', 'valentino'):
      return 'valentino';

    case process.env.REACT_APP_DOMAIN.replace('{brand}', 'red'):
      return 'red';

    default:
      throw new Error("Unknown currentBrand. Make sure the domain is correct and the app correctly configured.");
  }
}
